<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.atendimento.problemasCondicoes"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(ciap)="{item}">
                {{item.ciap ? `${item.ciap.codigo} - ${item.ciap.descricao}` : ''}}
            </template>

            <template v-slot:cell(cid)="{item}">
                {{item.cid ? `${item.cid.codigo} - ${item.cid.nome}` : ''}}
            </template>

            <template v-slot:cell(actions)="{item}">
                <rkm-button
                    :disabled="(hasGravidezAltoRisco && isGravidezNormal(item)) || item.automatico || (item.hasContinuidade ?? false)"
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    :disabled="(hasGravidezAltoRisco && isGravidezNormal(item)) || item.automatico || (item.hasContinuidade ?? false)"
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

// Mixins.
import {atencaoBasicaAtendimentoIndividualPreNatal} from '@/mixins'

export default {
    components: {Modal},
    computed: {
        hasGravidezAltoRisco() {
            return this.getProblemasCondicoesGravidezAltoRisco().length > 0
        },
    },
    data: () => ({
        fields: [
            {key: 'ciap', label: 'CIAP 2', sortable: true},
            {key: 'cid', label: 'CID 10', sortable: true},
            {key: 'situacaoNome', label: 'Situação', sortable: true},
            {key: 'inicio.data', label: 'Início', sortable: true},
            {key: 'fim.data', label: 'Fim', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'}
        ],
    }),
    methods: {
        destroy(item) {
            this.showDeleteConfirmation('Deseja realmente excluir o problema/condição?', async () => {
                if (this.isGravidezAltoRisco(item)) {
                    const problemaCondicaoGravidezNormal = this.getProblemaCondicaoGravidezNormal()

                    if (problemaCondicaoGravidezNormal && problemaCondicaoGravidezNormal.automatico) {
                        this.data.model.atendimento.problemasCondicoes.splice(this.data.model.atendimento.problemasCondicoes.indexOf(problemaCondicaoGravidezNormal), 1)
                    }
                }
                this.data.model.atendimento.problemasCondicoes.splice(this.data.model.atendimento.problemasCondicoes.indexOf(item), 1)
            })
        },
        getProblemaCondicaoGravidezNormal() {
            return this.data.model.atendimento.problemasCondicoes.find(this.isGravidezNormal)
        },
        getProblemasCondicoesGravidezAltoRisco() {
            return this.data.model.atendimento.problemasCondicoes.filter(this.isGravidezAltoRisco)
        },
    },
    mixins: [atencaoBasicaAtendimentoIndividualPreNatal],
    props: {
        data: {type: Object, required: true},
    },
}
</script>